import merge from "lodash/merge";

class AttendIdentity {
  constructor() {
      this.id = 0,
      this.name = "",//姓名
      this.code = "",//编号
      this.discount = "",//折扣
      this.note = ""//备注
  }
  static getAttendIdentityList(filters) {

    const url = process.env.VUE_APP_API_URL + 'api/v1/attendidentity'
    if (!filters.per_page || filters.per_page == '') {
      filters.per_page = -1
    }
    return axios.get(url, { params: filters }).then((res) => {
      let result = {}
      result.attendidentity_list = Array()
      res.data.forEach((x) => {
        let c = new AttendIdentity()
        Object.assign(c, x)
        result.attendidentity_list.push(c)
      })
      result.total = res.data.total
      return result
    })
  }
  createOrUpdateAttendIdentity() {
    const url =
      process.env.VUE_APP_API_URL + "api/v1/attendidentity"
    if (this.id == 0) {
      //新增
      const data = merge({}, this);

      return axios.post(url, data).then((res) => {
        let result = new AttendIdentity();
        result = merge(result, res);
        return result;
      });
    } else {
      //修改
      const data = merge({}, this);
      return axios
        .put(url, data)
        .then((res) => {
          let result = new AttendIdentity();
          result = merge(result, res);
          return result;
        });
    }
  }
  static delete(id) {
    const url = process.env.VUE_APP_API_URL + "api/v1/attendidentity/"
    return axios.delete(url, { params: { id: id } }).then(res => {
      return true
    })
  }


}
export { AttendIdentity };
